import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Marquee from '../components/Marquee/Marquee';
import Footer from '../components/Footer/Footer';
import Home from '../pages/Home/Home';
import About from '../pages/About/About';
import Courses from '../pages/Courses/Courses';
import Contact from '../pages/Contact/Contact';
import PressReleases from '../pages/PressReleases/PressReleases';
import ScrollToTop from '../components/ScrollToTop';
// Import admin components
import AdminLogin from '../pages/Admin/Login';
import Dashboard from '../pages/Admin/Dashboard';
import '../styles/Pages.css';
import './App.css';

// Layout component for public pages
const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <Marquee />
    <div className="page-wrapper">
      {children}
    </div>
    <Footer />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          {/* Admin routes - no layout */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/*" element={<Dashboard />} />

          {/* Public routes with layout */}
          <Route path="/" element={
            <PublicLayout>
              <Home />
            </PublicLayout>
          } />
          <Route path="/about" element={
            <PublicLayout>
              <About />
            </PublicLayout>
          } />
          <Route path="/courses" element={
            <PublicLayout>
              <Courses />
            </PublicLayout>
          } />
          <Route path="/contact" element={
            <PublicLayout>
              <Contact />
            </PublicLayout>
          } />
          <Route path="/press-releases" element={
            <PublicLayout>
              <PressReleases />
            </PublicLayout>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;